import React from 'react'

import './index.scss'

export const SwapIcon: React.FC = () => (
  <svg className="icon icon--swap" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      className="stroke"
      d="M7.33334 4L4.66667 6.66667M4.66667 6.66667L7.33334 9.33333M4.66667 6.66667H15.3333M12.6667 16L15.3333 13.3333M15.3333 13.3333L12.6667 10.6667M15.3333 13.3333H4.66667"
      strokeLinecap="square"
    />
  </svg>
)
